import dayjs from "dayjs";

import { useArticleContentRefMap } from "@EditArticleContainer/shared/contexts/ArticleContentRefContext";
import {
  REF_CODE_EXPEDITED_PROGRAM_DESIGNATED_COMPANY_NAME,
  REF_CODE_EXPEDITED_PROGRAM_DESIGNATED_INDICATION,
  REF_CODE_EXPEDITED_PROGRAM_DESIGNATION_BASIS_AND_CLINICAL_SIGNIFICANCE,
  REF_CODE_EXPEDITED_PROGRAM_EXPEDITED_PROGRAM,
  REF_CODE_EXPEDITED_PROGRAM_REGULATORY_AGENCY,
  REF_CODE_EXPEDITED_PROGRAM_UPDATE_DATE,
  REF_CODE_SEPARATOR,
} from "@EditArticleContainer/shared/libs/refCode/constants/refCode.constants";
import { createRefCode } from "@EditArticleContainer/shared/libs/refCode/utils/createRefCode";
import { ExpeditedProgramContent } from "@EditArticleContainer/shared/types/paragraphContents/contents/expeditedProgramContent.types";
import { createContentFromHTML } from "@EditArticleContainer/shared/utils/getValueFromRefMap";

export const useCreateExpeditedProgramTableContent = () => {
  const refMap = useArticleContentRefMap();

  const indexList = [...refMap.keys()]
    .filter(
      (key) => key.indexOf(REF_CODE_EXPEDITED_PROGRAM_EXPEDITED_PROGRAM) !== -1,
    )
    .map((key) => key.split(REF_CODE_SEPARATOR)[1]);

  return () => {
    const content: ExpeditedProgramContent = {
      text: {
        "Expedited Program Contents": indexList.map((index) => ({
          "Update Date": createContentFromHTML(
            refMap,
            createRefCode(REF_CODE_EXPEDITED_PROGRAM_UPDATE_DATE, index),
          ),
          "Designated Company name": createContentFromHTML(
            refMap,
            createRefCode(
              REF_CODE_EXPEDITED_PROGRAM_DESIGNATED_COMPANY_NAME,
              index,
            ),
          ),
          "Regulatory Agency": createContentFromHTML(
            refMap,
            createRefCode(REF_CODE_EXPEDITED_PROGRAM_REGULATORY_AGENCY, index),
          ),
          "Expedited Program": createContentFromHTML(
            refMap,
            createRefCode(REF_CODE_EXPEDITED_PROGRAM_EXPEDITED_PROGRAM, index),
          ),
          "Designated Indication": createContentFromHTML(
            refMap,
            createRefCode(
              REF_CODE_EXPEDITED_PROGRAM_DESIGNATED_INDICATION,
              index,
            ),
          ),
          "Designation Basis & Clinical Significance": createContentFromHTML(
            refMap,
            createRefCode(
              REF_CODE_EXPEDITED_PROGRAM_DESIGNATION_BASIS_AND_CLINICAL_SIGNIFICANCE,
              index,
            ),
          ),
        })),
      },
      labels: [],
      updateDt: dayjs().toISOString(),
    };

    return content;
  };
};
